import { render, staticRenderFns } from "./claimDetail.vue?vue&type=template&id=27f1f2e2&scoped=true"
import script from "./claimDetail.vue?vue&type=script&lang=js"
export * from "./claimDetail.vue?vue&type=script&lang=js"
import style0 from "./claimDetail.vue?vue&type=style&index=0&id=27f1f2e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f1f2e2",
  null
  
)

export default component.exports